/**
 * BLACKSTONE MOBILE FIXES — blackstoneclothes.com
 */

(function () {
  'use strict';

  var isMobile = window.innerWidth <= 768;
  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

  function initStickyHeader() {
    if (!isMobile) return;
    var selectors = ['#shopify-section-header','.header-section','.site-header','.header__wrapper','.main-header','.bs-header'];
    var headerEl = null;
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.getBoundingClientRect().height > 20) { headerEl = el; break; }
    }
    if (!headerEl) return;
    var bg = window.getComputedStyle(headerEl).backgroundColor;
    if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') bg = '#000000';
    headerEl.style.cssText += 'position: sticky !important; top: 0 !important; z-index: 1000 !important; background-color: ' + bg + ' !important;';
  }

  function initStickyATC() {
    if (!isMobile || !isProductPage) return;
    var mainATC = document.querySelector('button[name="add"]') || document.querySelector('.product-form__submit') || document.querySelector('[class*="add-to-cart"]') || document.querySelector('button[type="submit"][class*="btn"]');
    if (!mainATC) return;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1.product-single__title') || document.querySelector('h1');
    var priceEl = document.querySelector('.price-item--regular') || document.querySelector('.product__price .money') || document.querySelector('[class*="product-price"] .money') || document.querySelector('.price .money');
    var titleText = titleEl ? titleEl.textContent.trim() : 'This Product';
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var bar = document.createElement('div');
    bar.id = 'bs-sticky-atc-bar';
    bar.innerHTML = '<div class="bs-atc-product-info"><span class="bs-atc-title">' + escapeHtml(titleText) + '</span><span class="bs-atc-price">' + escapeHtml(priceText) + '</span></div><button class="bs-atc-btn" type="button">Add to Cart</button>';
    document.body.appendChild(bar);
    var stickyBtn = bar.querySelector('.bs-atc-btn');
    function syncPrice() { var p = document.querySelector('.price-item--regular') || document.querySelector('.product__price .money'); if (p) bar.querySelector('.bs-atc-price').textContent = p.textContent.trim(); }
    document.addEventListener('variant:changed', syncPrice);
    document.addEventListener('variantChanged', syncPrice);
    var atcObserver = new IntersectionObserver(function(entries) { entries.forEach(function(entry) { if (entry.isIntersecting) { bar.classList.remove('bs-visible'); var b = document.getElementById('bs-back-to-top'); if (b) b.classList.remove('bs-atc-open'); } else { bar.classList.add('bs-visible'); var b = document.getElementById('bs-back-to-top'); if (b) b.classList.add('bs-atc-open'); } }); }, { threshold: 0 });
    atcObserver.observe(mainATC);
    stickyBtn.addEventListener('click', function() { stickyBtn.classList.add('bs-loading'); stickyBtn.textContent = 'Adding...'; mainATC.click(); setTimeout(function() { stickyBtn.classList.remove('bs-loading'); stickyBtn.textContent = 'Add to Cart'; }, 2000); });
  }

  function initBackToTop() {
    var btn = document.createElement('button');
    btn.id = 'bs-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '&#8679;';
    document.body.appendChild(btn);
    var scrollTimer = null;
    function onScroll() { if (scrollTimer) return; scrollTimer = setTimeout(function() { scrollTimer = null; if (window.scrollY > 300) btn.classList.add('bs-visible'); else btn.classList.remove('bs-visible'); }, 100); }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function fixCustomCursor() {
    if (!isTouch) return;
    ['.cursor-wrapper','[class*="cursor-dot"]','[class*="cursor-follow"]','[class*="custom-cursor"]','.cursor'].forEach(function(sel) { var el = document.querySelector(sel); if (el) { el.style.display = 'none'; el.style.visibility = 'hidden'; } });
    document.documentElement.style.cursor = 'auto';
  }

  function fixAnnouncementBars() {
    if (!isMobile) return;
    var trustBar = document.querySelector('.bs-trust-bar');
    if (trustBar) trustBar.setAttribute('aria-hidden', 'true');
  }

  function fixImageLayoutShift() {
    var selectors = ['.product__media img','.product-single__media img','[class*="product-photo"] img','[class*="product-image"] img','.featured-image img'];
    selectors.forEach(function(sel) { document.querySelectorAll(sel).forEach(function(img) { if (!img.hasAttribute('width') || !img.hasAttribute('height')) { if (!img.style.aspectRatio && !img.style['aspect-ratio']) { img.style.aspectRatio = '3 / 4'; img.style.width = '100%'; img.style.objectFit = 'cover'; } } }); });
    var mc = document.querySelector('.product__media-list, .product-single__media-list, [class*="product-gallery"]');
    if (mc && typeof MutationObserver !== 'undefined') { var o = new MutationObserver(function() { selectors.forEach(function(sel) { document.querySelectorAll(sel).forEach(function(img) { if (!img.hasAttribute('width') || !img.hasAttribute('height')) { img.style.aspectRatio = '3 / 4'; img.style.width = '100%'; img.style.objectFit = 'cover'; } }); }); }); o.observe(mc, { childList: true, subtree: true }); }
  }

  function initMobileNavAccordion() {
    if (!isTouch) return;
    var subMenuData = {};
    document.querySelectorAll('.menu-lv-item.menu-lv-1').forEach(function(item) {
      var topLink = item.querySelector('.menu-lv-1__action');
      if (!topLink) return;
      var topKey = topLink.textContent.trim().toUpperCase();
      var topHref = topLink.href || topLink.getAttribute('href') || '#';
      var megaMenu = item.querySelector('.menu-dropdown');
      if (!megaMenu) return;
      var sections = [];
      megaMenu.querySelectorAll('.site-nav.dropdown').forEach(function(col) {
        var headerEl = col.querySelector('.site-nav-title');
        if (!headerEl) return;
        var headerText = headerEl.textContent.trim();
        var headerHref = headerEl.href || headerEl.getAttribute('href') || topHref;
        var subItems = [];
        col.querySelectorAll('.site-nav-sub a').forEach(function(a) {
          var text = a.textContent.trim();
          if (text && !text.toLowerCase().includes('go to')) {
            subItems.push({ text: text, href: a.href || a.getAttribute('href') || '#' });
          }
        });
        if (subItems.length > 0) {
          sections.push({ header: headerText, href: headerHref, items: subItems });
          subMenuData[headerText.toUpperCase()] = [{ header: headerText, href: headerHref, items: subItems }];
        }
      });
      if (sections.length === 0) {
        var flatItems = [];
        megaMenu.querySelectorAll('a').forEach(function(a) {
          var text = a.textContent.trim();
          if (text && !text.toLowerCase().includes('go to')) {
            flatItems.push({ text: text, href: a.href || a.getAttribute('href') || '#' });
          }
        });
        if (flatItems.length > 0) {
          sections.push({ header: topKey.charAt(0) + topKey.slice(1).toLowerCase(), href: topHref, items: flatItems });
        }
      }
      if (sections.length > 0) { subMenuData[topKey] = sections; }
    });
    if (Object.keys(subMenuData).length === 0) return;
    function buildSubmenuEl(sections) {
      var wrap = document.createElement('div');
      wrap.className = 'bs-mobile-submenu';
      sections.forEach(function(sec) {
        var secDiv = document.createElement('div');
        secDiv.className = 'bs-mobile-submenu-section';
        var hdr = document.createElement('a');
        hdr.href = sec.href;
        hdr.className = 'bs-mobile-submenu-header';
        hdr.textContent = sec.header;
        secDiv.appendChild(hdr);
        var ul = document.createElement('ul');
        sec.items.forEach(function(sub) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = sub.href;
          a.textContent = sub.text;
          li.appendChild(a);
          ul.appendChild(li);
        });
        secDiv.appendChild(ul);
        wrap.appendChild(secDiv);
      });
      return wrap;
    }
    function injectSubmenus(container) {
      container.querySelectorAll('.menu-lv-1').forEach(function(item) {
        if (item.querySelector('.bs-mobile-submenu')) return;
        var link = item.querySelector('a');
        if (!link) return;
        var key = link.textContent.trim().toUpperCase();
        var sections = subMenuData[key];
        if (!sections) return;
        item.classList.remove('no-megamenu');
        item.classList.add('bs-has-submenu');
        var btn = document.createElement('button');
        btn.className = 'bs-submenu-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Expand ' + key.charAt(0) + key.slice(1).toLowerCase());
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M7.75 2L6.25 3.31 14.66 12 6.25 20.69 7.75 22 17.34 12Z"/></svg>';
        item.appendChild(btn);
        var submenu = buildSubmenuEl(sections);
        item.appendChild(submenu);
        btn.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          var isOpen = item.classList.contains('bs-open');
          container.querySelectorAll('.bs-has-submenu.bs-open').forEach(function(oi) {
            oi.classList.remove('bs-open');
            var s = oi.querySelector('.bs-mobile-submenu');
            if (s) s.style.maxHeight = '0';
            var b = oi.querySelector('.bs-submenu-toggle');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('bs-open');
            submenu.style.maxHeight = (submenu.scrollHeight + 200) + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }
    var navContainer =
      document.querySelector('[data-navigation-tab-mobile]') ||
      document.querySelector('[data-navigation-mobile]') ||
      document.querySelector('.halo-sidebar_menu .halo-sidebar-wrapper');
    if (!navContainer) return;
    if (navContainer.children.length > 0) injectSubmenus(navContainer);
    var navObserver = new MutationObserver(function() { injectSubmenus(navContainer); });
    navObserver.observe(navContainer, { childList: true, subtree: true });
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function init() {
    fixCustomCursor();
    fixAnnouncementBars();
    initBackToTop();
    fixImageLayoutShift();
    initMobileNavAccordion();
    // initStickyHeader() disabled — Ella uses built-in <sticky-header> web component
    if (isMobile && isProductPage) initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
